import React, { useEffect, useState } from 'react';
import HeaderEntreprise from '../../header/headerEntreprise';
import Footer from '../../commun/Footer';
import FactureList from '../../commun/FactureList';

const FacturesEntreprise = () => {
  const entrepriseId = localStorage.getItem('entrepriseId');
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const entrepriseName = localStorage.getItem("entrepriseName");

  const columns = [
    { key: 'numeroFacture', label: 'Facture #' },
    { key: 'mission', label: 'Mission' },
    { key: 'recruteur', label: 'Recruteur' },
    { key: 'montant', label: 'Montant' },
    { key: 'statut', label: 'Statut' },
    { key: 'dateCreation', label: 'Date de création' },
  ];

  return (
    <>
    <HeaderEntreprise entrepriseName={entrepriseName} />

    <FactureList
      fetchUrl={`${API_BASE}/api/entreprise/facture/${entrepriseId}`}
      headerComponent={HeaderEntreprise}
      footerComponent={Footer}
      columns={columns}
      userType="Entreprise"
    />
    </>
  );
};

export default FacturesEntreprise;
